import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TooltipComponent } from './tooltip.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: TooltipComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class TooltipRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/tooltip/tooltip-routing.module.ts